import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	filterButtonsArialabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.popup-select.button.filter-buttons-arialabel',
		defaultMessage:
			'{buttonLabel} filter menu{buttonSelectedValue, select, null {} other {: {buttonSelectedValue}}}',
		description:
			'AriaLabel text for dependencies filter buttons, where {buttonLabel} is the name of the filter button and {buttonSelectedValue} is the selected option from the filters dropdown',
	},
});
